<!-- APP--APP管理--支付配置 -->
<template>
  <div>
    <!-- 表单-阿里 -->
    <div class="md-layout">
      <div class="md-layout md-layout-item md-size-60 mx-auto md-xsmall-size-100"> 
        <label class="md-layout-item md-size-20 md-form-label md-form-label-out">{{$I18n("alipay")}}:</label>
        <div class="md-layout-item md-size-80 md-form-item">
          <md-field>
            <md-select v-model="form.ali">
              <md-option value="">{{$I18n("un_use")}}</md-option>
              <md-option v-for="item in data.ali" :key="item.id" :value="item.id">{{item.remark}}</md-option>
            </md-select>
          </md-field>
        </div>
      </div>
    </div>
    <!-- 表单-微信 --> 
    <div class="md-layout">
      <div class="md-layout md-layout-item md-size-60 mx-auto md-xsmall-size-100"> 
        <label class="md-layout-item md-size-20 md-form-label md-form-label-out">{{$I18n("wechart")}}:</label>
        <div class="md-layout-item md-size-80 md-form-item">
          <md-field>
            <md-select v-model="form.wx">
              <md-option value="">{{$I18n("un_use")}}</md-option>
              <md-option v-for="item in data.wx" :key="item.id" :value="item.id">{{item.remark}}</md-option>
            </md-select>
          </md-field>
        </div>
      </div>
    </div>
    <!-- 表单-paypal -->
    <div class="md-layout">
      <div class="md-layout md-layout-item md-size-60 mx-auto md-xsmall-size-100"> 
        <label class="md-layout-item md-size-20 md-form-label md-form-label-out">{{$I18n("paypal")}}:</label>
        <div class="md-layout-item md-size-80 md-form-item">
          <md-field>
            <md-select v-model="form.pay">
              <md-option value="">{{$I18n("un_use")}}</md-option>
              <md-option v-for="item in data.pay" :key="item.id" :value="item.id">{{item.remark}}</md-option>
            </md-select>
          </md-field>
        </div>
      </div>
    </div>
    <!-- 表单-payu -->
    <div v-show="false" class="md-layout">
      <div class="md-layout md-layout-item md-size-60 mx-auto md-xsmall-size-100"> 
        <label class="md-layout-item md-size-20 md-form-label md-form-label-out">{{$I18n("payu")}}:</label>
        <div class="md-layout-item md-size-80 md-form-item">
          <md-field>
            <md-select v-model="form.payu">
              <md-option value="">{{$I18n("un_use")}}</md-option>
              <md-option v-for="item in data.payu" :key="item.id" :value="item.id">{{item.remark}}</md-option>
            </md-select>
          </md-field>
        </div>
      </div>
    </div>
    <!-- 表单-Stripe -->
    <div class="md-layout">
      <div class="md-layout md-layout-item md-size-60 mx-auto md-xsmall-size-100"> 
        <label class="md-layout-item md-size-20 md-form-label md-form-label-out">{{$I18n("stripe")}}:</label>
        <div class="md-layout-item md-size-80 md-form-item">
          <md-field>
            <md-select v-model="form.stripe">
              <md-option value="">{{$I18n("un_use")}}</md-option>
              <md-option v-for="item in data.stripe" :key="item.id" :value="item.id">{{item.remark}}</md-option>
            </md-select>
          </md-field>
        </div>
      </div>
    </div>
    <!-- 表单-Paytm -->
    <div class="md-layout">
      <div class="md-layout md-layout-item md-size-60 mx-auto md-xsmall-size-100"> 
        <label class="md-layout-item md-size-20 md-form-label md-form-label-out">{{$I18n("paytm")}}:</label>
        <div class="md-layout-item md-size-80 md-form-item">
          <md-field>
            <md-select v-model="form.paytm">
              <md-option value="">{{$I18n("un_use")}}</md-option>
              <md-option v-for="item in data.paytm" :key="item.id" :value="item.id">{{item.remark}}</md-option>
            </md-select>
          </md-field>
        </div>
      </div>
    </div>
    <!-- 表单-razorpay -->
    <div class="md-layout">
      <div class="md-layout md-layout-item md-size-60 mx-auto md-xsmall-size-100"> 
        <label class="md-layout-item md-size-20 md-form-label md-form-label-out">{{$I18n("razorpay")}}:</label>
        <div class="md-layout-item md-size-80 md-form-item">
          <md-field>
            <md-select v-model="form.razorpay">
              <md-option value="">{{$I18n("un_use")}}</md-option>
              <md-option v-for="item in data.razorpay" :key="item.id" :value="item.id">{{item.remark}}</md-option>
            </md-select>
          </md-field>
        </div>
      </div>
    </div>
    <!-- 表单-applepay -->
    <div class="md-layout">
      <div class="md-layout md-layout-item md-size-60 mx-auto md-xsmall-size-100"> 
        <label class="md-layout-item md-size-20 md-form-label md-form-label-out">{{"Apple pay"}}:</label>
        <div class="md-layout-item md-size-80 md-form-item">
          <md-field>
            <md-select v-model="form.applepay">
              <md-option value="">{{$I18n("un_use")}}</md-option>
              <md-option v-for="item in data.applepay" :key="item.id" :value="item.id">{{item.remark}}</md-option>
            </md-select>
          </md-field>
        </div>
      </div>
    </div>
    <!-- 表单-提交按钮 -->
    <md-button @click="modal_openModal" class="md-info right-button">{{$I18n("sure")}}</md-button>
    <!-- 弹窗 -->
    <modal key="main" v-show="modal" @close="modal_closeModal" class="lg-modal">
      <!-- 弹窗-头部 -->
      <template slot="header">
        <h4 class="modal-title">{{$I18n("tips")}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modal_closeModal">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <!-- 弹窗-主体 -->
      <template slot="body">
        <div>{{$I18n("is_sure_edit")}}</div>
      </template>
      <!-- 弹窗-底部按钮 -->
      <template slot="footer">
        <md-button @click="modal_submit" class="left-icon md-info">{{$I18n("sure")}}</md-button>
        <md-button @click="modal_closeModal" class="">{{$I18n("cancel")}}</md-button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Modal } from '@/components';
export default {
  components: {
    Modal,
  },
  props: {
    app_id : {
      type: String,
      default: "",
    },
 },
  data(){
    return {
      modal: false, // 弹窗是否打开了
      form : {      // 表单选择的数据
        ali : "",
        wx  : "",
        pay : "",
        payu: "",
        stripe : "",
        paytm : "",
        razorpay: "",
        applepay: "",
      },
      data : {      // 完整的支付数据
        ali: [],
        wx : [],
        pay: [],
        payu:[],
        stripe : [],
        paytm : [],
        razorpay: [],
        applepay: [],
      },
    }
  },
  methods: {
    modal_openModal (){ // 弹窗-打开弹窗
      this.modal = true;
    },
    modal_closeModal(){ // 弹窗-关闭弹窗
      this.modal = false;
    },
    modal_submit(){ // 弹窗-提交修改
      let ids = [];
      for(let key in this.form){
        if(this.form[key]){
          ids.push(this.form[key])
        }
      }
      this.$api.setAppPaymentRela({ // api: /pay/appid/set
        ids,
        app_id : this.app_id,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("edit_success"));
          this.modal_closeModal();
          this.api_getPaymentSet();
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    api_getPaymentSet(){ // API-获取对应 "APP ID" 的支付配置
      this.form = {
        ali:"",
        wx :"",
        pay:"",
        payu:"",
        stripe : "",
        paytm : "",
        razorpay: "",
        applepay: "",
      }
      return this.$api.getPaymentSet({ // api: /pay/appid/query
        app_id : this.app_id,
        type: 0,
      })
        .then(this.$Then(res => {
          // 1 阿里, 2 微信, 3 PayPal
          if(res.data && res.data.length > 0){
            res.data.forEach(item => {
              switch (parseInt(item.platform_type)) {
                case 1:
                  this.form.ali = item.id;
                  break;
                case 2:
                  this.form.wx = item.id;
                  break;
                case 3:
                  this.form.pay = item.id;
                  break;
                case 6:
                  this.form.payu = item.id;
                  break;
                case 7:
                  this.form.stripe = item.id;
                  break;
                case 8:
                  this.form.paytm = item.id;
                  break;
                case 9:
                  this.form.razorpay = item.id;
                  break
                case 10:
                  this.form.applepay = item.id;
                  break
              }
            })
          }
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.form = {
            ali:"",
            wx :"",
            pay:"",
            payu:"",
            stripe : "",
            paytm : "",
            razorpay:"",
            applepay:"",
          }
        }))
    },
    api_getAllPaymentSet(){// API-获取所有的支付配置
      this.data = {
        ali: [],
        wx : [],
        pay: [],
        payu:[],
        stripe : [],
        paytm : [],
        razorpay: [],
        applepay: [],
      }
      return this.$api.getPaymentSet({ // api: /pay/appid/query
        app_id: "",
        type  : 0,
      })
        .then(this.$Then(res => {
          // 1 阿里, 2 微信, 3 PayPal
          res.data.forEach(item => {
            switch (parseInt(item.platform_type)) {
              case 1:
                this.data.ali.push(item);
                break;
              case 2:
                this.data.wx.push(item);
                break;
              case 3:
                this.data.pay.push(item);
                break;
              case 6:
                this.data.payu.push(item)
                break;
              case 7:
                this.data.stripe.push(item)
                break;
              case 8:
                this.data.paytm.push(item)
                break;
              case 9:
                this.data.razorpay.push(item)
                break;
              case 10:
                this.data.applepay.push(item)
                break;
            }
          });
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.form = [];
        }))
    },
  },
  created(){
    this.api_getAllPaymentSet()
      .then(() => {
        if(this.app_id){
          this.api_getPaymentSet()
        }
      })
  },
}
</script>